module.exports = __webpack_public_path__ + "img/newsLogo1.1e2ecbfc.png";